import React from 'react';
import Lottie from 'lottie-react';
import './Hero.css';

const translations = {
  ar: {
    title: 'أفضل تطبيق لحجز الملاعب في سوريا',
    subtitle: 'احجز ملعبك المفضل بسهولة وسرعة من أي مكان',
    download: 'حمّل التطبيق الآن'
  },
  en: {
    title: 'Best Stadium Booking App in Syria',
    subtitle: 'Book your favorite stadium easily and quickly from anywhere',
    download: 'Download Now'
  }
};

function Hero({ language }) {
  const t = translations[language];

  const scrollToDownload = () => {
    document.getElementById('download')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">{t.title}</h1>
            <p className="hero-subtitle">{t.subtitle}</p>
            <button className="btn btn-primary hero-btn" onClick={scrollToDownload}>
              {t.download}
              <span className="btn-icon">📱</span>
            </button>
          </div>
          <div className="hero-image">
            <Lottie 
              animationData={require('../animations/stadium.json')} 
              loop={true}
              className="hero-animation"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
